import { AccessibilityType, Destination, Experience, Facility, Meal, Period, RentalUnitType, RoomType, TargetAudience, Transportation } from '@toevla-webapplications/core';
import { ThemeType } from '../offers/theme-type.enum';
import { ConditionType } from '../offers/condition-type.enum';

const CRM_IDS: { [key: string]: string } = {
	[AccessibilityType.AUDITIVE]: '915fbfee-6e1e-ef11-840a-000d3ade305e',
	[AccessibilityType.MENTAL]: '200beefa-6e1e-ef11-840a-000d3ade305e',
	[AccessibilityType.MOTOR]: '2ca9e2f4-6e1e-ef11-840a-000d3ade305e',
	[AccessibilityType.VISUAL]: 'b2df2d01-6f1e-ef11-840a-000d3ade305e',

	[ConditionType.BEHAVIOUR]: '421700d1-5a1f-ef11-840a-000d3ade305e',
	[ConditionType.BOYS]: '23eb9dc3-5a1f-ef11-840a-000d3ade305e',
	[ConditionType.DEV_DISORDER]: '410403cb-5a1f-ef11-840a-000d3ade305e',
	[ConditionType.FYSICAL]: 'c97ec14d-7c21-ef11-840a-0022489b516f',
	[ConditionType.GIRLS]: '36eb9dc3-5a1f-ef11-840a-000d3ade305e',
	[ConditionType.MENTAL_DISABILITY]: '280403cb-5a1f-ef11-840a-000d3ade305e',
	[ConditionType.SPECIFIC]: '7c1700d1-5a1f-ef11-840a-000d3ade305e',
	[ConditionType.VULNERABILITY]: '6a1700d1-5a1f-ef11-840a-000d3ade305e',

	[Destination.ABROAD]: 'e3fead99-621e-ef11-840a-000d3a691183',
	[Destination.BELGIUM]: '66fead99-621e-ef11-840a-000d3a691183',

	[Experience.AGRITOURISM]: 'f34ca69f-621e-ef11-840a-000d3a691183',
	[Experience.CITYTRIP]: '48ad116c-501f-ef11-840a-000d3ade305e',
	[Experience.CHILD_FRIENDLY]: 'dcd40772-501f-ef11-840a-000d3ade305e',
	[Experience.ART_CULTURE]: 'fdd31078-501f-ef11-840a-000d3ade305e',
	[Experience.REST_NATURE]: '3b0d347e-501f-ef11-840a-000d3ade305e',
	[Experience.RELAX_WELLNESS]: '0d0d347e-501f-ef11-840a-000d3ade305e',
	[Experience.SPORT_EXERCISE]: '6b1f3a8a-501f-ef11-840a-000d3ade305e',
	[Experience.SILENCE_REST]: '791f3a8a-501f-ef11-840a-000d3ade305e',
	[Experience.WATER]: 'a1e33196-501f-ef11-840a-000d3ade305e',

	[Facility.AIRCO]: 'f4d9a62f-501f-ef11-840b-002248999d25',
	[Facility.ALL_DOGS_ALLOWED]: 'f0d9a62f-501f-ef11-840b-002248999d25',
	[Facility.ANIMATION]: '584c6599-4f1f-ef11-840a-000d3ade305e',
	[Facility.BAR_CAFE_CAFETARIA]: '65702464-c655-ed11-bba2-0022489931f5',
	[Facility.BAR_CAFETARIA_VENDING_MACHINE]: '51c6ffb0-6e1e-ef11-840a-000d3ade305e',
	[Facility.BIKES_FREE]: 'e6d9a62f-501f-ef11-840b-002248999d25',
	[Facility.BIKES_PAID]: 'e8d9a62f-501f-ef11-840b-002248999d25',
	[Facility.BUS_STOP_STATION_CLOSEBY]: 'ac03e9a4-6e1e-ef11-840a-000d3ade305e',
	[Facility.CARE]: 'f2d9a62f-501f-ef11-840b-002248999d25',
	[Facility.CHILD_FRIENDLY_FACILITIES]: 'dcd9a62f-501f-ef11-840b-002248999d25',
	[Facility.DISHWASHER]: 'fcd9a62f-501f-ef11-840b-002248999d25',
	[Facility.ELEVATOR]: 'dc14ebc2-6e1e-ef11-840a-000d3ade305e',
	[Facility.FITNESS]: 'ecd9a62f-501f-ef11-840b-002248999d25',
	[Facility.FREE_PARKING]: 'c514f8b6-6e1e-ef11-840a-000d3ade305e',
	[Facility.GROUP_ALLOWED]: '5e15f8b6-6e1e-ef11-840a-000d3ade305e',
	[Facility.INDOOR_PLAYGROUND]: 'dad9a62f-501f-ef11-840b-002248999d25',
	[Facility.INDOOR_POOL_ALL_YEAR]: '3c81e59f-4f1f-ef11-840a-000d3ade305e',
	[Facility.INDOOR_POOL_SEASONAL]: '2ff7d7b1-4f1f-ef11-840a-000d3ade305e',
	[Facility.OUTDOOR_POOL_ALL_YEAR]: 'd2d9a62f-501f-ef11-840b-002248999d25',
	[Facility.OUTDOOR_POOL_SEASONAL]: 'd4d9a62f-501f-ef11-840b-002248999d25',
	[Facility.PAID_PARKING]: '222ab582-4035-ef11-8409-000d3ab19a9f',
	[Facility.PARKING]: 'ded9a62f-501f-ef11-840b-002248999d25',
	[Facility.PICKNICK_POSSIBLE]: 'c239fbc8-6e1e-ef11-840a-000d3ade305e',
	[Facility.PLAYGROUND]: 'd8d9a62f-501f-ef11-840b-002248999d25',
	[Facility.RELAXATION_AREA]: 'eed9a62f-501f-ef11-840b-002248999d25',
	[Facility.RESTAURANT]: '3844ba57-c655-ed11-bba2-0022489931f5',
	[Facility.RESTAURANT_OR_SNACKBAR]: '78e752cf-6e1e-ef11-840a-000d3ade305e',
	[Facility.SHUTTLE_SERVICE_FREE]: 'e2d9a62f-501f-ef11-840b-002248999d25',
	[Facility.SHUTTLE_SERVICE_PAID]: 'e4d9a62f-501f-ef11-840b-002248999d25',
	[Facility.SWIMMING_POND]: 'd6d9a62f-501f-ef11-840b-002248999d25',
	[Facility.TELEVISION]: 'f6d9a62f-501f-ef11-840b-002248999d25',
	[Facility.WASHING_MACHINE]: 'fed9a62f-501f-ef11-840b-002248999d25',
	[Facility.WELLNESS]: 'ead9a62f-501f-ef11-840b-002248999d25',
	[Facility.WHEEL_CHAIR_FREE]: '514f91dc-6e1e-ef11-840a-000d3ade305e',
	[Facility.WHEEL_CHAIR_PAID]: 'cb9d89e2-6e1e-ef11-840a-000d3ade305e',
	[Facility.WIFI]: '65a9d692-fa7e-ee11-8179-000d3ab37cfd',

	[Meal.BREAKFAST]: 'ecebfa39-501f-ef11-840a-000d3ade305e',
	[Meal.FULL_BOARD]: '5dbbd540-501f-ef11-840a-000d3ade305e',
	[Meal.GLUTEN_FREE]: '2a51804d-501f-ef11-840a-000d3ade305e',
	[Meal.HALF_BOARD]: '45bbd540-501f-ef11-840a-000d3ade305e',
	[Meal.SELF_CATERING]: '60674c47-501f-ef11-840a-000d3ade305e',
	[Meal.SPECIAL_MENU]: '73fd0d60-501f-ef11-840a-000d3ade305e',

	[Period.ALL_YEAR_ROUND]: '82793874-471f-ef11-840a-0022489b516f',
	[Period.HOLIDAYS_CHRISTMAS]: 'b93f156e-471f-ef11-840a-0022489b516f',
	[Period.HOLIDAYS_EASTER]: '0008d755-471f-ef11-840a-0022489b516f',
	[Period.HOLIDAYS_FALL]: 'a6247918-471f-ef11-840a-0022489b516f',
	[Period.HOLIDAYS_KROKUS]: 'd607d755-471f-ef11-840a-0022489b516f',
	[Period.HOLIDAYS_SUMMER]: 'f2ad7912-471f-ef11-840a-0022489b516f',
	[Period.LONG_WEEKEND_ASCENSION]: '69b61862-471f-ef11-840a-0022489b516f',
	[Period.LONG_WEEKEND_PENTECOST]: '9e3f156e-471f-ef11-840a-0022489b516f',
	[Period.MIDWEEK]: 'd8024b7a-471f-ef11-840a-0022489b516f',
	[Period.OUTSIDE_SCHOOL_HOLIDAYS]: '0d32cf7a-3239-ef11-8409-000d3ab19a9f',
	[Period.WEEKEND]: 'bf024b7a-471f-ef11-840a-0022489b516f',

	[RentalUnitType.APPARTMENT]: '8b5114fe-431f-ef11-840a-000d3ade305e',
	[RentalUnitType.BOAT]: 'e767921c-441f-ef11-840a-000d3ade305e',
	[RentalUnitType.BUNGALOW]: 'fc67921c-441f-ef11-840a-000d3ade305e',
	[RentalUnitType.CAMPSITE]: '32f0a422-441f-ef11-840a-000d3ade305e',
	[RentalUnitType.DORMITORY]: '20fc7d10-441f-ef11-840a-000d3ade305e',
	[RentalUnitType.HOUSE]: '153c2904-441f-ef11-840a-000d3ade305e',
	[RentalUnitType.LOG_CABIN]: 'e98f9016-441f-ef11-840a-000d3ade305e',
	[RentalUnitType.MOBILE_HOME]: '7d2aa928-441f-ef11-840a-000d3ade305e',
	[RentalUnitType.OTHER]: '4dbcb035-441f-ef11-840a-000d3ade305e',
	[RentalUnitType.ROOM]: '6bb1280a-441f-ef11-840a-000d3ade305e',
	[RentalUnitType.STUDIO]: '023c2904-441f-ef11-840a-000d3ade305e',
	[RentalUnitType.TENT]: '18218b2f-441f-ef11-840a-000d3ade305e',
	[RentalUnitType.UNIT]: '39218b2f-441f-ef11-840a-000d3ade305e',

	[RoomType.FAMILY_ROOM]: '6270e94f-fb39-ef11-8409-002248a0ac8a',
	[RoomType.SINGLE_ROOM]: 'f9f9892e-fb39-ef11-8409-002248a0ac8a',

	[TargetAudience.CHILDREN_0_6]: '3d302f38-621e-ef11-840a-000d3a691183',
	[TargetAudience.CHILDREN_6_12]: '592b0f44-6e1e-ef11-840a-000d3ade305e',
	[TargetAudience.ADOLESCENTS_12_18]: '0e7b074a-6e1e-ef11-840a-000d3ade305e',
	[TargetAudience.ADULT_18_22]: '00012356-6e1e-ef11-840a-000d3ade305e',
	[TargetAudience.ADULT_22_65]: '45ea565c-6e1e-ef11-840a-000d3ade305e',
	[TargetAudience.SENIOR_65]: 'e8227a62-6e1e-ef11-840a-000d3ade305e',
	[TargetAudience.FAMILY]: '6a237a62-6e1e-ef11-840a-000d3ade305e',

	[ThemeType.ACTION]: '4dd3ca86-591f-ef11-840b-002248999d25',
	[ThemeType.ANIMALS]: 'c537174e-591f-ef11-840b-002248999d25',
	[ThemeType.ANIMATOR]: '1a360c15-651e-ef11-840a-000d3ade305e',
	[ThemeType.CREATIVE]: '95c8de0c-661e-ef11-840a-000d3ade305e',
	[ThemeType.DIGITAL]: 'c737174e-591f-ef11-840b-002248999d25',
	[ThemeType.GAMES]: 'c937174e-591f-ef11-840b-002248999d25',
	[ThemeType.LANGUAGE]: 'd337174e-591f-ef11-840b-002248999d25',
	[ThemeType.MUSIC]: 'd537174e-591f-ef11-840b-002248999d25',
	[ThemeType.OTHER_INTERESTS]: 'd737174e-591f-ef11-840b-002248999d25',
	[ThemeType.REST]: 'cd37174e-591f-ef11-840b-002248999d25',
	[ThemeType.SCIENCE]: 'cb37174e-591f-ef11-840b-002248999d25',
	[ThemeType.SPORT]: 'd137174e-591f-ef11-840b-002248999d25',

	[Transportation.BOARDING_POINT]: 'a8c26687-3239-ef11-8409-000d3ab19a9f',
	[Transportation.CARPOOL]: '95869299-3239-ef11-8409-000d3ab19a9f',
	[Transportation.HOME_PICKUP]: 'add29793-3239-ef11-8409-000d3ab19a9f',
	[Transportation.OWN_TRANSPORT]: '13ce6f8d-3239-ef11-8409-000d3ab19a9f',
};

type CrmType = AccessibilityType | Destination | Experience | Facility | Meal | Period | RoomType | TargetAudience | Transportation | string;

export function convertToCrmId(value: CrmType): string {
	return CRM_IDS[value] || value;
}

export function convertFromCrmId(value: string): CrmType | null {
	for (const key in CRM_IDS) {
		if (CRM_IDS[key] === value) {
			return key;
		}
	}

	return null;
}
